import * as React from "react";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Stack, Tooltip, Typography, IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
export default function Milestone({
  onclose,
  subscriptionFormData,
  milestoneList,
  setSubscriptionFormData,
}: any) {
  const handleSwitch = (
    event: React.SyntheticEvent,
    mileStone: any,
    mileStoneId: string
  ) => {
    const { checked }: any = event.target;
    setSubscriptionFormData((prev: any) => {
      let mileStoneArray =
        prev.mileStoneType === "whatsApp"
          ? [...prev.whatsAppmilestones]
          : prev.mileStoneType === "whatsappGroup"
          ? [...prev.whatsappGroupmilestones]
          : ([...prev.emailsmilestones] as any);
      if (checked) {
        mileStoneArray = [...mileStoneArray, mileStone?._id];
      } else {
        mileStoneArray = mileStoneArray.filter((id: any) => id !== mileStoneId);
      }

      return {
        ...prev,
        [`${prev.mileStoneType}milestones`]: mileStoneArray,
      };
    });
  };

  const onSelectAllMileStone = (e: React.SyntheticEvent) => {
    setSubscriptionFormData((prev: any) => {
      const { checked }: any = e.target;
      let mileStoneArray = [];
      if (checked) {
        mileStoneArray = prev?.milestoneList
          ?.filter((item: any) => !item.isAchived)
          .map((item: { _id: any }) => item?._id);
      } else {
        mileStoneArray = [];
      }

      return {
        ...prev,
        [`${prev.mileStoneType}milestones`]: mileStoneArray,
      };
    });
  };

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} mb={4}>
        <Tooltip title="Go Back">
          <IconButton className="arrowBackIcon"  onClick={onclose}>
            <ArrowBackIcon/>
          </IconButton>
        </Tooltip>
        <Typography className="flex gap-2 items-center" variant="body2" color="textSecondary">
          Include/Exclude milestone <ArrowUpwardIcon className="arrowUpwardIcon" />
        </Typography>
      </Stack>
      <FormControl component="fieldset">
        <FormGroup aria-label="position">
          <FormControlLabel
            value="top"
            control={
              <Switch
                className="thinSwitch"
                onChange={(e) => onSelectAllMileStone(e)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "black",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "black",
                  },
                }}
              />
            }
            checked={
              subscriptionFormData?.mileStoneType === "whatsApp"
                ? subscriptionFormData?.whatsAppmilestones?.length ===
                  milestoneList?.length
                : subscriptionFormData?.mileStoneType === "whatsappGroup"
                ? subscriptionFormData?.whatsappGroupmilestones?.length ===
                  milestoneList?.length
                : subscriptionFormData?.emailsmilestones?.length ===
                  milestoneList?.length
            }
            label="Add all"
            labelPlacement="start"
            sx={{ marginRight: 2 }}
          />
          {milestoneList?.map((milestone: any, index: number) => (
            <FormControlLabel
              value="top"
              key={milestone?._id}
              disabled={milestone?.isAchived}
              control={
                <Switch
                  className="thinSwitch"
                  key={milestone?._id}
                  checked={
                    subscriptionFormData.mileStoneType === "whatsApp"
                      ? subscriptionFormData.whatsAppmilestones.includes(
                          milestone?._id
                        )
                      : subscriptionFormData.mileStoneType === "whatsappGroup"
                      ? subscriptionFormData.whatsappGroupmilestones.includes(
                          milestone?._id
                        )
                      : subscriptionFormData.emailsmilestones.includes(
                          milestone?._id
                        )
                  }
                  onChange={(e) => handleSwitch(e, milestone, milestone?._id)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "black",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "black",
                    },
                  }}
                />
              }
              label={milestone?.label}
              labelPlacement="start"
              sx={{ marginRight: 2 }}
            />
          ))}
        </FormGroup>
      </FormControl>
    </>
  );
}
